import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import Page from "../components/Page";
import styles from "./ClosingRound.module.scss";
import ProgressLine from "../components/ProgressLine";

const POLLING_INTERVAL = 15000;

const ClosingRound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let timeoutId;
    let isUnmounted = false;

    const checkClosingStatus = async () => {
      try {
        const { data: jobs } = await API.fetchJobs();

        const isClosingInProgress = jobs.includes("CLOSE_ROUND");

        if (!isClosingInProgress) {
          navigate("/administration", { replace: true });
          return;
        }
      } catch (error) {
        console.error("Unable to check round closing status", error);
      }

      if (!isUnmounted) {
        timeoutId = window.setTimeout(checkClosingStatus, POLLING_INTERVAL);
      }
    };

    timeoutId = window.setTimeout(checkClosingStatus, POLLING_INTERVAL);

    return () => {
      isUnmounted = true;
      window.clearTimeout(timeoutId);
    };
  }, [navigate]);

  return (
    <Page>
      <section className={styles.closingRound} aria-live="polite">
        <div className={styles.plWrapper}>
          <ProgressLine />
        </div>
        <h2>Триває закриття туру</h2>
        <p>
          Будь ласка, зачекайте декілька хвилин. Сторінка оновиться автоматично.
        </p>
      </section>
    </Page>
  );
};

export default ClosingRound;
